import { BaSeIcon, BaSeInput } from "@base/react";
import { useRef, useEffect, useState } from "react";
import "./index.scss";
import Button from "../../../components/button/button";
import { formatCurrency } from "../../../services/utils";

const PostCreditCashFlow = ({ date, data, onChange, onSubmit, isCollapsed, onCollapse, income, lab, isDisabled = false }) => {
  const contentRef = useRef(null);
  const infoBoxRef = useRef(null);

  const [exitData, setExitData] = useState(data || []);
  const [isInitialMount, setIsInitialMount] = useState(true);

  const togglePaid = (uuid) => {
    if (isDisabled) return;

    setExitData((prev) => {
      const updatedMonth = {
        ...prev[0],
        entries: prev[0].entries.map((entry) => 
          entry.uuid === uuid ? { ...entry, pago: !entry.pago } : entry
        )
      };
      
      return [updatedMonth];
    });
  };

  const handleSubmit = () => {
    if (onSubmit) {
      onSubmit(exitData);
    } else {
      onChange?.(null, exitData);
    }
  };

  useEffect(() => {
    if (isInitialMount) {
      setIsInitialMount(false);
      return;
    }
    
    if (onChange) {
      onChange(exitData);
    }
  }, [exitData, onChange, isInitialMount]);

  useEffect(() => {
    if (contentRef.current) {
      const panel = contentRef.current.closest(".panel");
      if (panel && panel.classList.contains("open")) {
        panel.style.maxHeight = `${panel.scrollHeight}px`;
      }
    }
  }, [isCollapsed, exitData]);

  useEffect(() => {
    const element = infoBoxRef.current;
    if (!element) return;

    clearTimeout(element._hideTimeout);

    if (isCollapsed) {
      element._hideTimeout = setTimeout(() => {
        element.classList.add("hidden");
      }, 360);
    } else {
      element.classList.remove("hidden");
    }
  }, [isCollapsed]);

  return (
    <div className="post-credit-cash-flow">
      <div
        ref={infoBoxRef}
        className={`cash-flow-info-box ${isCollapsed ? "collapsed" : ""}`}
      >
        <div className="information-box-header">
          <span>Fique atento(a)!</span>
          <BaSeIcon
            color="#2E5DE6"
            description="Fechar informações"
            name="close"
            onClick={onCollapse}
            size={16}
          />
        </div>
        <p>
          As informações do <strong>fluxo de caixa projetado</strong> são
          essenciais para entender a saúde financeira do seu negócio.
          Mantenha-as atualizadas e baseadas em dados reais para garantir
          indicadores mais precisos.
        </p>
      </div>
      <div className="cash-flow-date-container">{date}</div>
      <div ref={contentRef} className="cash-flow-main-content">
        {(exitData[0]?.entries.entrada || income) && (
          <div>
            <h4>Entradas</h4>
            <BaSeInput prefix="R$ " width={lab ? 650 : 330} label="Todas as entradas" value={(exitData[0]?.entries.entrada || income)} isDisabled />
          </div>
        )}

        <div className="cash-flow-exit">
          {exitData[0]?.entries?.length > 0 ? 
            <>
              <h4>Saídas</h4>
              <div className="cash-flow-exit-grid">
                {exitData[0]?.entries.map((item, index) => (
                  <div key={index} className="cash-flow-exit-item" style={{ gridTemplateColumns: `${lab ? '1fr 1fr' : ''}` }}>
                    <BaSeInput label="Identificação" value={item.title} isDisabled />
                    <BaSeInput prefix="R$ " label="Valor" value={formatCurrency(item.val?.toFixed(2).toString()) ?? '0'} isDisabled />
                    {!lab && <div className="toggle-wrapper">
                      <label className="toggle-label" htmlFor={`paid-toggle-${index}`}>
                        Pago?
                      </label>
                      <button
                        type="button"
                        id={`paid-toggle-${index}`}
                        className={`cash-flow-toggler ${item.pago ? "pending" : "paid"}`}
                        onClick={() => togglePaid(item.uuid)}
                        disabled={isDisabled}
                      >
                        <div className="toggler-track">
                          <div className="toggler-thumb" />
                        </div>
                      </button>
                    </div>}
                  </div>
                ))}
              <BaSeInput
                width={lab ? 650 : 330}
                label="Todas as saídas"
                prefix="R$ "
                value={formatCurrency(exitData[0]?.entries.reduce((acc, item) => acc + (item.val || 0), 0).toFixed(2).toString())}
                isDisabled
              />
              </div>
            </>
          :
            <p>Nenhuma saída registrada.</p>
          }
        </div>
      </div>
      {!lab && <div className="send-button">
        <Button callback={handleSubmit} disabled={isDisabled}>Atualizar</Button>
      </div>}
    </div>
  );
};

export default PostCreditCashFlow;
